import PageNotFoundError from '../../domain/error/PageNotFoundError'
import * as itineraryHPPage from '../../domain/itinerary/itineraryHP.page'
import { setStepFromParams } from '../../store/itinerary/itinerary.actions'
import { SEO_MODES_TO_MULTIPATH_MODES } from '../../store/itinerary/itinerary.constants'
import { setCurrentMode } from '../../store/itinerary/itinerarySlice'
import { handleRouteLoading } from '../routeService'
import * as itineraryHPAction from './itineraryHP.route'

export function onRouteEnter({ params: { mode, to }, store: { dispatch, getState }, routeContext: { state } }) {
  return itineraryHPAction.onRouteEnter.apply(null, arguments).then(() => {
    const modeId = SEO_MODES_TO_MULTIPATH_MODES[mode]
    if (!modeId) throw new PageNotFoundError(`Le mode "${mode}" est inconnu.`)
    dispatch(setCurrentMode(modeId))

    setStepFromParams({ to, toAddress: state.toAddress }, { force: true })(dispatch, getState)
  })
}

function onRouteLeave() {
  /*
  - exécuter itineraryHP.onRouteLeave
   */
}

export default handleRouteLoading({
  onRouteEnter,
  renderPage: itineraryHPPage.renderPage,
  onRouteLeave
})
